export default __webpack_public_path__ + "static/media/Lab_Partner_1_PCR_Product.30d73378.svg";